import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectService } from 'src/app/modules/project/services/project.service';

@Component({
  selector: 'app-reject',
  templateUrl: './reject.component.html',
  styleUrls: ['./reject.component.css']
})
export class RejectComponent {
  projectId!: string;
  userId!: string;
  status!: number; // Status will be retrieved from the URL
  invitationMessage!: string;
  constructor(private activeRoute: ActivatedRoute, private project: ProjectService) {}

  ngOnInit(): void {
    // Get query parameters for rejection
    this.activeRoute.queryParams.subscribe(params => {
      this.projectId = params['project_id'];
      this.userId = params['user_id'];
      this.status = params['status']; // Retrieve the status from the URL

      if (this.projectId && this.userId && this.status) {
        this.rejectProject();
      } 
    });
  }

  /**
   * Rejects project
   */
  rejectProject(): void {
    this.project.getRejectUserStatus(this.projectId, this.userId, this.status).subscribe({
      next: (response: any) => {
        // Handle success response
        if (response.status_code === 200) {
          // Success response handling
          this.invitationMessage = response.message; // "Your invitation has been accepted"
        }
      },
      error: (error: any) => {  
        // Handle error response
          // Error response handling
          this.invitationMessage = error.error.message; // "Project invite already accepted"          
        
      }
    });
  }
}